import React, { useEffect, useState } from 'react';

import NumericInput from '../../../../shared/components/numeric-input/numeric-input';
import { HabitNumericInputDetails } from './types';

type HabitSliderDetailsPropType = {
  onChange: (value: number) => void;
} & HabitNumericInputDetails;

const HabitNumericInput = ({
  currentValue,
  minValue,
  maxValue,
  onChange,
  questionKey,
  allowDecimals,
}: HabitSliderDetailsPropType) => {
  const [selectedValue, setSelectedValue] = useState<number>(currentValue ?? minValue);

  useEffect(() => {
    if (currentValue !== undefined) {
      setSelectedValue(currentValue);
    }
  }, [currentValue]);

  const handleOnChange = (value: number) => {
    setSelectedValue(value);
    onChange(value);
  };

  return (
    <div className="habit__input">
      <NumericInput
        min={minValue}
        max={maxValue}
        value={selectedValue}
        onChange={handleOnChange}
        aria-labelledby={questionKey}
        allowDecimals={allowDecimals}
      />
    </div>
  );
};

export default HabitNumericInput;
